import React, {Component} from 'react';
import {message} from 'antd';
import {querySaveIncubator} from '@api/incubator/base';
import FormEdit from './FormEdit';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  handSubmit = item => {
    const context = this;
    querySaveIncubator(item).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        context.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    return <FormEdit handSubmit={this.handSubmit} data={dataInfo} />;
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/components/incubator/base/PageAdd.js